<div class="reset-password-page">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <span class="breadcrumb__item">Home</span>
      <span class="breadcrumb__separator" aria-hidden="true">/</span>
      <span class="breadcrumb__item breadcrumb__item--current" aria-current="page"
        >Reset Password</span
      >
    </nav>
  </header>

  <mat-card class="reset-card" appearance="outlined">
    <mat-card-content>
      <h1 class="reset-card__heading">Reset Password</h1>

      @if (errorMessage()) {
        <div class="inline-error" role="alert" aria-live="assertive">{{ errorMessage() }}</div>
      }

      <form class="reset-form" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <div class="field-group">
          <label class="field-label" for="resetEmail">Email Address</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              id="resetEmail"
              type="email"
              formControlName="email"
              placeholder="you@company.com"
              autocomplete="email"
            />
            <mat-hint>Enter your email to receive a password reset link</mat-hint>
            <mat-error>
              @if (emailControl.hasError('required')) {
                Email address is required
              } @else if (emailControl.hasError('email')) {
                Please enter a valid email address
              }
            </mat-error>
          </mat-form-field>
        </div>

        <button
          mat-flat-button
          type="submit"
          class="full-width"
          [disabled]="isLoading() || form.invalid"
        >
          @if (isLoading()) {
            <mat-spinner diameter="20" />
          } @else {
            Send Reset Link
          }
        </button>
        <div class="reset-form__back">
          <a [routerLink]="['/auth/login']" class="link">Back to Login</a>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
